import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {AdminApi} from "../Api/AdminApi";
import {DayInput, SelectInput, TextAreaInput, TextInput} from "../Components/Input/Input";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import {push} from "../Utils/validation";
import {Tab, Tabs} from "react-bootstrap";

const PLATFORMS = {
    'UNKNOWN': 'Unset',
    'TEXT_MESSAGE': 'Text Message',
    'EMAIL': 'Email',
    'IOS': 'iOS (Unsupported)',
    'SAFARI': 'Safari (Unsupported)',
    'CHROME': 'Chrome (Unsupported)',
}

const EMAIL_TEMPLATES = {
    'UNKNOWN': 'Unknown',
    'COMPLETE_PROFILE': 'Complete Profile',
    'HOW_IT_WORKS': 'How it works',
    'REFERRAL_EMAIL': 'Referrals',
}

const RECIPIENTS = {
    'UNKNOWN': 'Unset',
    'ALL': 'Everyone',
    'CURRENT': 'Current Students',
    'PROSPECTIVE': 'Prospective Students',
}


const NotificationsDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [notificationPageData, setNotificationsPageData] = useState(null);
    const [selectedNotificationGroup, setSelectedNotificationGroup] = useState(null);
    const [showCreateNotificationModal, setShowCreateNotificationModal] = useState(false);
    const notificationTableHeader = ['ID', 'Subject', 'Message', 'Platforms', 'Recipient', 'Dispatch Time', 'Time Read']
    const [resetFilter, setResetFilter] = useState(false)
    const [filerOpen, setFilterOpen] = useState(false)
    const [topic, setTopic] = useState('')
    const [tab, setTab] = useState('Dispatched')

    useEffect(() => {
        if (resetFilter) {
            setTopic('')
        }
    }, [resetFilter])

    function toggleFilter() {
        setFilterOpen(!filerOpen)
    }

    function updateTopic(e) {
        setTopic(e?.target?.value.replaceAll(' ', '-'))
        setFilterOpen(false)
    }

    useEffect(() => {
        AdminApi.User.getAdminPageNotificationsData({}, session.jwt).then(res => {
            setNotificationsPageData(res.data);
            if (res.data?.notificationGroups?.length > 0) {
                setSelectedNotificationGroup(res.data?.notificationGroups[0])
            }
        }).catch(error => {
            if (error.message?.includes( '404')) {
                setSessionCookie({})
                window.location.href = window.location.hostname
            }
        })
    }, [session.jwt])

    return <div>
        <SideBar session={session} title={"Manage Notifications"}>
            <div className={s.adminDashboard}>
                <CreateNotificationModal notificationPageData={notificationPageData} showCreateNotificationModal={showCreateNotificationModal} hideCreateNotificationModal={() => setShowCreateNotificationModal(false)} />
                <main className={s.dataSection}>
                    <div className={s.viewModalButtonContainer}>
                        <div onClick={() => {
                            setShowCreateNotificationModal(true)
                        }} className={`${s.createCampaignCard}`}>
                            <div className={s.createCampaignCardBody}>
                                Create Notification
                            </div>
                        </div>
                    </div>

                    <h3 className='heading'>{(notificationPageData?.notificationGroups ?? []).length} Total Notification
                        Groups</h3>

                    <div className={s.campaignListContainer}>
                        <div className={s.campaignList}>
                            {notificationPageData ? notificationPageData?.notificationGroups?.map((group, idx) =>
                                    <NotificationGroupCard selectedNotificationGroup={selectedNotificationGroup}
                                                           setSelectedNotificationGroup={setSelectedNotificationGroup}
                                                           group={group}/>
                                ) :
                                <>
                                    <NotificationGroupCard/>
                                    <NotificationGroupCard/>
                                    <NotificationGroupCard/>
                                    <NotificationGroupCard/>
                                </>}
                        </div>
                    </div>

                    <h3 className='heading mt-4'>{(selectedNotificationGroup?.notifications ?? []).length} Total
                        Notifications</h3>
                    <div className={s.dataTableContainer}>
                        <Tabs className='mb-4 '
                              activeKey={tab}
                              onSelect={(k) => setTab(k)}>
                            <Tab eventKey="Pending" title={<span className='d-flex align-items-center'>Pending</span>}>
                                <NotificationTable
                                    data={(selectedNotificationGroup?.notifications ?? []).filter(notification => !notification.dispatchTime)}
                                    headers={notificationTableHeader}/>
                            </Tab>
                            <Tab eventKey="Dispatched"
                                 title={<span className='d-flex align-items-center'>Dispatched</span>}>
                                <NotificationTable
                                    data={(selectedNotificationGroup?.notifications ?? []).filter(notification => notification.dispatchTime && !notification.timeRead)}
                                    headers={notificationTableHeader}/>
                            </Tab>
                            <Tab eventKey="Read" title={<span className='d-flex align-items-center'>Read</span>}>
                                <NotificationTable
                                    data={(selectedNotificationGroup?.notifications ?? []).filter(notification => notification.dispatchTime && notification.timeRead)}
                                    headers={notificationTableHeader}/>
                            </Tab>
                        </Tabs>
                    </div>
                </main>
                <aside className={s.filterSection}>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Filter Notifications</div>
                            <div className={s.filterCardFilterToggle}>
                                <Button className={`btnLink`}
                                        onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                            </div>
                        </Card.Title>
                        <div className={s.mobile}>
                            {filerOpen &&
                                <>
                                    <Card.Body className={'my-0'}>
                                        <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                                onClick={updateTopic} value={''}>All Notifications</Button>
                                        {[].map((blogTopic, idx) =>
                                            <Button key={idx}
                                                    className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                                    onClick={updateTopic}
                                                    value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                        )}
                                    </Card.Body>
                                </>
                            }
                        </div>
                        <div className={s.desktop}>
                            <Card.Body className={'my-1'}>
                                <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                        onClick={updateTopic} value={''}>All Notifications</Button>
                                {[].map((blogTopic, idx) =>
                                    <Button key={idx}
                                            className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                            onClick={updateTopic}
                                            value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                )}
                            </Card.Body>
                        </div>
                    </Card>
                </aside>
            </div>
        </SideBar>
    </div>
}


const CreateNotificationModal = ({ notificationPageData, showCreateNotificationModal, hideCreateNotificationModal }) => {
    const {session} =  useContext(SessionContext);
    const [request, setRequest] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    const resetForm = () => {
        setFormErrors({});
        setRequest({})
        setLoading(false)
        setError(undefined)
    };

    const createNotification = () => {
        setLoading(true)
        setFormErrors({});
        setError(undefined)

        const errors = validateRequest(request);
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            setLoading(false)
            return;
        }

        AdminApi.Notifications.createNotifications(request, session.jwt).then((res) => {
            setRequest({})
            setFormErrors({});
            setError(undefined)
            hideCreateNotificationModal()
        }).catch((ignored) => {
            setLoading(false)
            setError('Unable to create the notification')
        });
    }

    function validateRequest(req) {
        const errors = {};
        if (!req.subject) {
            push(errors, 'subject', 'A subject is required');
        }
        if (!req.platform || (req.platform?.toLowerCase() !== 'email' && req.platform?.toLowerCase() !== 'text_message')) {
            push(errors, 'platform', 'A supported platform is required');
        }

        if (req.platform?.toLowerCase() === 'text_message' && !req.textMessage) {
            push(errors, 'textMessage', 'A message is required');
        }

        if (req.platform?.toLowerCase() === 'email' && !req.emailTemplate && !req.emailMessage) {
            push(errors, 'emailTemplate', 'A template or message is required');
            push(errors, 'emailMessage', 'A template or message is required');
        }

        if (req.platform?.toLowerCase() === 'email' && req.emailTemplate?.toLowerCase() === 'unknown' && !req.emailMessage) {
            push(errors, 'emailTemplate', 'A valid template or message is required');
            push(errors, 'emailMessage', 'A valid template or message is required');
        }

        if (req.platform?.toLowerCase() === 'email' && (req.emailTemplate?.length > 0) && req.emailTemplate?.toLowerCase() !== 'unknown' && req.emailMessage?.length > 0) {
            push(errors, 'emailTemplate', 'You must pick between an email template or providing your own');
            push(errors, 'emailMessage', 'You must pick between an email template or providing your own');
        }

        if (!req.recipientAddresses && !req.recipient) {
            push(errors, 'recipient', 'A recipient is required');
            push(errors, 'recipientAddresses', 'A recipient is required');
        }

        if (req.recipient?.toLowerCase() === 'unknown' && req.recipientAddresses?.length === 0) {
            push(errors, 'recipientAddresses', 'A recipient is required');
        }

        if (req.recipient?.length > 0 && req.recipient?.toLowerCase() !== 'unknown' && req.recipientAddresses?.length > 0) {
            push(errors, 'recipient', 'You must pick between a recipient and providing some');
            push(errors, 'recipientAddresses', 'You must pick between a recipient and providing some');
        }

        if (req.dispatchNow === undefined) {
            push(errors, 'dispatchNow', 'A dispatch time is required');
        }

        if (req.dispatchNow === false && !req.dispatchDateTime) {
            push(errors, 'dispatchDateTime', 'A dispatch time is required');
        }

        if (req.dispatchDateTime && new Date(req.dispatchDateTime) < Date.now()) {
            push(errors, 'dispatchDateTime', 'You must pick a day into the future');
        }

        return errors;
    }

    function handleChange(event) {
        const { name, value } = event.target;
        setRequest((prevState) => ({ ...prevState, [name]: value }));
    }

    function handleChangeDay(selectedDay, modifiers, dayPickerInput) {
        setRequest(prevState => ({...prevState, dispatchDateTime: dayPickerInput.getInput().value}))
    }

    function dispatchNow(decision) {
        setRequest(prevState => ({...prevState, dispatchNow: decision}))
    }

    return <Modal fullscreen={'md-down'} show={showCreateNotificationModal} onShow={resetForm} onHide={() => hideCreateNotificationModal()}>
        <Modal.Header closeButton/>
        <Modal.Title>
            <h3 style={{textAlign: 'center'}}>Send New Notification</h3>
        </Modal.Title>
        <Modal.Body>
            <div className={`${s.interactionLogList} px-1`}>
                <Form>
                    <SelectInput containerClassName='mb-2 mt-2' id={'campaignId'}
                                 label="Campaign"
                                 placeholder={'Select Campaign'}
                                 options={notificationPageData?.campaigns ?? {}} errors={formErrors}
                                 name="campaignId"
                                 value={request.campaignId} onChange={handleChange}/>

                    <TextInput containerClassName='mb-1' type="text" errors={formErrors} name="subject"
                               value={request.subject || ''}
                               onChange={handleChange} label="Subject"/>

                    <SelectInput containerClassName='mb-2 mt-2' id={'platform'}
                                 label="Platform"
                                 placeholder={'Select Platform'}
                                 options={notificationPageData?.platforms ?? PLATFORMS} errors={formErrors}
                                 name="platform"
                                 value={request.platform} onChange={handleChange}/>

                    {request.platform?.toLowerCase() === 'email' &&
                        <>
                            <SelectInput containerClassName='mb-2 mt-2' id={'emailTemplate'}
                                         label="Email Template"
                                         placeholder={'Select Template'}
                                         options={notificationPageData?.emailTemplates ?? EMAIL_TEMPLATES}
                                         errors={formErrors} name="emailTemplate"
                                         value={request.emailTemplate} onChange={handleChange}/>

                            <p className={'text-center mt-2 mb-0'}>or</p>

                            <TextAreaInput containerClassName='mb-2' type="text" errors={formErrors} name="emailMessage"
                                           value={request.emailMessage || ''}
                                           placeholder={`Insert raw text or use the <!DOCTYPE html> shebang`}
                                           onChange={handleChange} label="Email message"/>
                        </>
                    }

                    {request.platform?.toLowerCase() === 'text_message' &&
                        <TextAreaInput containerClassName='mb-2' type="text" errors={formErrors} name="textMessage"
                                       value={request.textMessage || ''}
                                       onChange={handleChange} label="Text Message"/>
                    }

                    <SelectInput containerClassName='mb-2 mt-2' id={'recipient'}
                                 label={`Recipients`}
                                 placeholder={'Not specified'}
                                 options={notificationPageData?.recipients ?? RECIPIENTS} errors={formErrors}
                                 name="recipient"
                                 value={request.recipient} onChange={handleChange}/>

                    <p className={'text-center mt-2 mb-0'}>or</p>

                    <TextAreaInput containerClassName='mb-2' type="text" errors={formErrors} name="recipientAddresses"
                                   value={request.recipientAddresses || ''}
                                   placeholder={`Comma separated`}
                                   onChange={handleChange}
                                   label={`Recipients' ${request.platform?.toLowerCase() === 'email' ? 'email' : 'phone numbers'}`}/>

                    <label className={'my-2'}>When should this dispatch?</label>
                    <div className={`${s.alwaysSideBySideContainer}`}>
                        <Button onClick={() => {
                            dispatchNow(true)
                        }}
                                className={`wide fw-bold fs-16 ${request.dispatchNow === true ? `btnFill` : `btnOutline`} py-2`}>
                            <div className={s.createCampaignCardBody}>
                                Now
                            </div>
                        </Button>

                        <Button onClick={() => {
                            dispatchNow(false)
                        }}
                                className={`wide fw-bold fs-16 ${request.dispatchNow === false ? `btnFill` : `btnOutline`} py-2`}>
                            <div className={s.createCampaignCardBody}>
                                Later
                            </div>
                        </Button>
                    </div>

                    {request.dispatchNow === false &&
                        <DayInput containerClassName='mb-3' errors={formErrors} name={'dispatchDateTime'}
                                  value={request.dispatchDateTime}
                                  label={'Which day should this dispatch at Noon'}
                                  onChange={handleChangeDay} placeholder={'Dispatch when? (MM/DD/YYYY)'}/>
                    }

                </Form>

                <Button onClick={createNotification}
                        disabled={loading}
                        className={`btnFill wide d-block mt-5 p-2 fs-16 fw-bold ${(Object.keys(validateRequest(request)).length > 0 || loading) ? 'bg-dark text-muted' : ''}`}>{loading ? "Sending..." : "Send Notification"}</Button>
                <p className={s.errorText}>{error ?? ''}</p>
            </div>
        </Modal.Body>
    </Modal>
};


const NotificationGroupCard = ({ group, selectedNotificationGroup, setSelectedNotificationGroup }) => {
    function toggleSelection() {
        if (setSelectedNotificationGroup) {
            if (selectedNotificationGroup?.id === group.id && group.id) {
                setSelectedNotificationGroup(undefined)
            } else {
                setSelectedNotificationGroup(group)
            }
        }
    }

    return <div onClick={toggleSelection} className={`${s.impressionCard} ${selectedNotificationGroup && selectedNotificationGroup === group ? s.selectedCard : ''}`}>
        {group ?
            <>
                <p style={{fontSize: '15px'}} className={`mt-2 mb-1`}>
                    <strong>Group ID:</strong> {group.groupIdentifier}
                </p>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerPurple}`}></div>
            </>
        }
        {group ?
            <>
                <p style={{fontSize: '15px'}} className={`mt-1 mb-1`}>
                    <strong>Title:</strong> {group.title}
                </p>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerPurple}`}></div>
            </>
        }

        {group ?
            <>
                <p style={{fontSize: '15px'}} className={`mt-1 mb-1`}>
                    <strong>Description:</strong> {group.description}
                </p>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerPurple}`}></div>
            </>
        }
    </div>
};


const NotificationTable = ({headers, data}) => {
    return (
        <table className={s.dataTable}>
            <thead className={s.dataTableHeader}>
            <tr>
                {headers.map((header) => (
                    <th key={header} scope="col">
                        {header}
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>
            {(data.length > 0 ? data : [{}]).toSorted((a, b) => b.id - a.id).map((row) => (
                <tr key={row.id} className={s.dataTableEntry}>
                    <td className={'py-4'}>
                        <button>
                            {row.id}
                        </button>
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.subject}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.message}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.platforms?.map((platform) => (
                            <p>{platform}</p>
                        ))}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.recipientId && row.recipientId}
                        {row.recipientEmail && row.recipientEmail}
                        {row.recipientPhone && row.recipientPhone}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.dispatchTime}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.timeRead}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};


export default (NotificationsDashboard);
